// src/components/AppLoadingSpinner.jsx

import React from 'react';

export default function AppLoadingSpinner() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-slate-50 dark:bg-gray-900">
      <div className="relative">
        {/* Background Track */}
        <div className="w-20 h-20 border-4 border-gray-200 dark:border-gray-700 rounded-full"></div>
        {/* Spinning Element */}
        <div className="w-20 h-20 border-4 border-t-transparent border-blue-500 dark:border-blue-400 rounded-full animate-spin absolute top-0 left-0"></div>
      </div>
      <p className="text-gray-500 dark:text-gray-400 mt-4 text-lg">Initializing...</p>
    </div>
  );
}